import { render, staticRenderFns } from "./GoogleMapLoader.vue?vue&type=template&id=063c2d56&"
import script from "./GoogleMapLoader.vue?vue&type=script&lang=js&"
export * from "./GoogleMapLoader.vue?vue&type=script&lang=js&"
import style0 from "./GoogleMapLoader.vue?vue&type=style&index=0&id=063c2d56&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063c2d56')) {
      api.createRecord('063c2d56', component.options)
    } else {
      api.reload('063c2d56', component.options)
    }
    module.hot.accept("./GoogleMapLoader.vue?vue&type=template&id=063c2d56&", function () {
      api.rerender('063c2d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoogleMapLoader.vue"
export default component.exports